// Deactivating a user, and deleting one — two acts in one dialog, because they are the
// same question asked with different force and the screen should make the milder one the
// obvious answer.
//
// ⚠ DEACTIVATION IS THE ORDINARY ACT and the dialog says why: it ends the person's access
// and cuts every session they hold immediately, while keeping every row they are named on
// — the tasks assigned to them, the files they uploaded, the meetings they booked.
//
// ⚠ DELETION ALMOST ALWAYS FAILS, and saying so up front is kinder than an error. Those
// same audit stamps reference `users` with no ON DELETE action, so the database refuses
// while any of them stands. The refusal arrives as `value_in_use` and is the honest
// answer: the record of who did something outlives their account.
//
// Neither act is offered for a partner who holds money, or for the last active partner —
// the row hides the buttons and the server refuses regardless. See ./roles.js and
// server/api/rest/users/guards.js.
import { useState } from 'react';
import he from '../../i18n/he';
import { usersAdminApi } from '../../api';
import Modal from '../../components/Modal';
import { ErrorText } from '../../components/Loader';

export default function StatusModal({ user, mode, onClose, onDone }) {
  const [error, setError] = useState(null);
  const destroying = mode === 'remove';

  const submit = async () => {
    try {
      const result = destroying
        ? await usersAdminApi.remove(user.id)
        : await usersAdminApi.setActive(user.id, false);
      // The count of sessions that died comes back from the server; the list reports it
      // so "they are locked out" is something the screen states rather than implies.
      onDone(result);
    } catch (e) {
      setError(e);
    }
  };

  return (
    <Modal
      title={destroying ? he.users.removeTitle(user.name) : he.users.deactivateTitle(user.name)}
      onClose={onClose}
      onSave={submit}
      saveLabel={destroying ? he.users.removeConfirm : he.users.deactivateConfirm}
    >
      <p>{destroying ? he.users.removeBody : he.users.deactivateBody}</p>
      {error && <ErrorText error={error} />}
    </Modal>
  );
}
